import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionStorage } from 'app/shared/storage/sessionstorage.service';
import { Observable } from 'rxjs';

@Injectable()
export class AgentInterceptor implements HttpInterceptor {

  constructor(
    private readonly sessionStorage: SessionStorage
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isAgent()) {
      const customerCode = this.sessionStorage.get('CustomerCode');
      if (customerCode) {
        request = request.clone({headers: request.headers.set('X-Customer-Code', customerCode)});
      }
    }
    return next.handle(request);
  }

  private isAgent(): boolean {
    return this.sessionStorage.get('IsAgent') === 'true';
  }
}
